const actions = {
    FETCH_SLIDES : 'FETCH_SLIDES',
    FETCH_SLIDE  : 'FETCH_SLIDE',
    RESET_SLIDE  : 'RESET_SLIDE',

    fetchSlidesAction: (data) => {
        return {
            type: actions.FETCH_SLIDES,
            data: data
        };
    },
    resetSlideFormAction: () => {
        return {
            type: actions.RESET_SLIDE,
            data: null
        };
    },
    fetchSlideAction: (data) => {
        return {
            type: actions.FETCH_SLIDE,
            data: data
        };
    },
}

export default actions;
